import { render, staticRenderFns } from "./RuoloMantra.vue?vue&type=template&id=5d61e1c4&scoped=true&"
import script from "./RuoloMantra.vue?vue&type=script&lang=js&"
export * from "./RuoloMantra.vue?vue&type=script&lang=js&"
import style0 from "./RuoloMantra.vue?vue&type=style&index=0&id=5d61e1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d61e1c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d61e1c4')) {
      api.createRecord('5d61e1c4', component.options)
    } else {
      api.reload('5d61e1c4', component.options)
    }
    module.hot.accept("./RuoloMantra.vue?vue&type=template&id=5d61e1c4&scoped=true&", function () {
      api.rerender('5d61e1c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/RuoloMantra.vue"
export default component.exports